export const SENSOR_CARLINE_LAUNCHABLE_ID = "env-3C5z7T9WtTr3dmDBU1lvBWUcfjj";
export const DEFECT_IMAGE_LAUNCHABLE_ID = "env-3DMiyRSFam5te8UXrCniX9QCu3x";
export const VIDEO_AUGMENTATION_LAUNCHABLE_ID = "env-3DH5QPdLRWBABdW9Lxn4vQBK5mW";
export const SENSOR_CARLINE_SKILL_FOLDER_URL = "https://github.com/NVIDIA/skills/tree/main/skills/physical-ai-neural-reconstruction";
export const DEFECT_IMAGE_SKILL_FOLDER_URL = "https://github.com/NVIDIA/skills/tree/main/skills/physical-ai-defect-image-generation";
export const VIDEO_AUGMENTATION_SKILL_FOLDER_URL = "https://github.com/NVIDIA/skills/tree/main/skills/physical-ai-video-data-augmentation";

export interface Pipeline {
  title: string;
  /** Short labels used as badge text on the landing page. */
  categories: string[];
  description: string;
  /** Approximate time shown on landing page cards, e.g. "~4 min". */
  timeToFirstOutput: string;
  /** Compact GPU label for landing page cards, e.g. "1× A100". */
  gpuRequirement: string;
  /** Full GPU spec used in requirements tables, e.g. "1× NVIDIA A100 (80 GB)". */
  gpuSpec: string;
  /** Comma-separated domain list used in requirements tables. */
  domains: string;
  poweredBy: string;
  launchableId: string;
  skillFolderUrl: string;
  learnMoreUrl: string;
}

export const PIPELINES: Pipeline[] = [
  {
    title: "Neural Reconstruction",
    categories: ["AV"],
    description:
      "Convert multi-sensor driving recordings into editable, photorealistic 3D scenes for simulation, training, and validation at scale, agent-driven from natural language prompts.",
    timeToFirstOutput: "~4 min",
    gpuRequirement: "1× A100",
    gpuSpec: "1× NVIDIA A100 (80 GB)",
    domains: "Autonomous Vehicles, Smart Spaces",
    poweredBy: "NVIDIA Omniverse NuRec",
    launchableId: SENSOR_CARLINE_LAUNCHABLE_ID,
    skillFolderUrl: SENSOR_CARLINE_SKILL_FOLDER_URL,
    learnMoreUrl: "https://docs.nvidia.com/brev/latest",
  },
  {
    title: "Defect Image Generation",
    categories: ["Manufacturing", "Vision AI"],
    description:
      "Generate synthetic defect images for PCBA, metal, and glass to enable high-accuracy Automated Optical Inspection (AOI). Train inspection models with minimal real defect data, accelerating new production introduction.",
    timeToFirstOutput: "~10 min",
    gpuRequirement: "2x RTX PRO 6K",
    gpuSpec: "2x RTX PRO 6K",
    domains: "Manufacturing, Vision AI",
    poweredBy: "NVIDIA Cosmos, NVIDIA Isaac Sim",
    launchableId: DEFECT_IMAGE_LAUNCHABLE_ID,
    skillFolderUrl: DEFECT_IMAGE_SKILL_FOLDER_URL,
    learnMoreUrl: "https://docs.nvidia.com/brev/latest",
  },
  {
    title: "Video Data Augmentation",
    categories: ["Robotics", "AV", "Vision AI", "Smart Spaces"],
    description:
      "Transform RGB video into diverse, high-fidelity, model-ready video datasets using agent skills to annotate, augment and evaluate videos in one unified workflow.",
    timeToFirstOutput: "~20 min",
    gpuRequirement: "4x RTX PRO 6K",
    gpuSpec: "4x RTX PRO 6K",
    domains: "Robotics, AV, Vision AI, Smart Spaces",
    poweredBy: "NVIDIA Cosmos",
    launchableId: VIDEO_AUGMENTATION_LAUNCHABLE_ID,
    skillFolderUrl: VIDEO_AUGMENTATION_SKILL_FOLDER_URL,
    learnMoreUrl: "https://docs.nvidia.com/brev/latest",
  },
];
